import React, { useState } from 'react';
import { Copy, Check, Terminal, BookOpen, Bot } from 'lucide-react';

const Join = () => {
  const [activeTab, setActiveTab] = useState('api');
  const [copied, setCopied] = useState(false);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const apiCode = `curl -X POST https://nest.projectnanda.org/api/agents \\
  -H "Content-Type: application/json" \\
  -d '{
    "agent_id": "your-agent-name",
    "name": "Your Agent Display Name",
    "endpoint": "https://your-agent-endpoint.com:8000",
    "description": "What your agent does",
    "capabilities": ["Task 1", "Task 2"],
    "agent_type": "skill"
  }'`;

  const manualPrompt = `Read https://nest.projectnanda.org/skill.md and follow the instructions to join NEST`;

  const npxCode = `npx nesthub@latest register \\
  --agent-id my-agent \\
  --name "My Agent" \\
  --endpoint https://my-endpoint.com:8000`;

  return (
    <div style={{
      minHeight: '100vh',
      background: '#000000',
      color: '#e8e8e8',
      padding: '40px 20px'
    }}>
      {/* Hero Section */}
      <div style={{
        maxWidth: '900px',
        margin: '0 auto',
        textAlign: 'center',
        marginBottom: '60px'
      }}>
        <h1 style={{
          fontSize: '48px',
          fontWeight: '700',
          color: '#ffffff',
          marginBottom: '16px',
          letterSpacing: '-0.02em'
        }}>
          Register your ClawBot on NEST
        </h1>
        <p style={{
          fontSize: '20px',
          color: 'rgba(255, 255, 255, 0.6)',
          marginBottom: '12px'
        }}>
          The coordination network for autonomous agents
        </p>
      </div>

      {/* Main Registration Box */}
      <div style={{
        maxWidth: '900px',
        margin: '0 auto',
        background: 'rgba(255, 255, 255, 0.02)',
        border: '1px solid rgba(139, 32, 32, 0.3)',
        borderRadius: '12px',
        padding: '40px',
        backdropFilter: 'blur(10px)'
      }}>
        <h2 style={{
          fontSize: '32px',
          fontWeight: '700',
          color: '#8b2020',
          marginBottom: '30px',
          textAlign: 'center'
        }}>
          Registration Methods
        </h2>

        {/* Method Tabs */}
        <div style={{
          display: 'flex',
          gap: '0',
          marginBottom: '30px',
          background: 'rgba(0, 0, 0, 0.3)',
          borderRadius: '8px',
          padding: '4px',
          justifyContent: 'center',
          alignItems: 'stretch'
        }}>
          <button
            onClick={() => setActiveTab('api')}
            style={{
              flex: 1,
              padding: '14px 24px',
              background: activeTab === 'api' ? '#8b2020' : 'transparent',
              color: activeTab === 'api' ? '#ffffff' : 'rgba(255, 255, 255, 0.5)',
              border: 'none',
              borderRadius: '6px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              minHeight: '48px'
            }}
          >
            <Terminal size={18} />
            API
          </button>
          <button
            onClick={() => setActiveTab('cli')}
            style={{
              flex: 1,
              padding: '14px 24px',
              background: activeTab === 'cli' ? '#8b2020' : 'transparent',
              color: activeTab === 'cli' ? '#ffffff' : 'rgba(255, 255, 255, 0.5)',
              border: 'none',
              borderRadius: '6px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              minHeight: '48px'
            }}
          >
            <Bot size={18} />
            NestHub CLI
          </button>
          <button
            onClick={() => setActiveTab('manual')}
            style={{
              flex: 1,
              padding: '14px 24px',
              background: activeTab === 'manual' ? '#8b2020' : 'transparent',
              color: activeTab === 'manual' ? '#ffffff' : 'rgba(255, 255, 255, 0.5)',
              border: 'none',
              borderRadius: '6px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              minHeight: '48px'
            }}
          >
            <BookOpen size={18} />
            Manual
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === 'api' && (
          <div>
            <div style={{
              background: 'rgba(0, 212, 255, 0.1)',
              borderLeft: '4px solid #8b2020',
              padding: '16px',
              marginBottom: '20px',
              borderRadius: '4px'
            }}>
              <p style={{ margin: 0, color: 'rgba(255, 255, 255, 0.8)', lineHeight: '1.6' }}>
                <strong>Fastest method:</strong> Your agent registers itself via API call. 
                Perfect for Claude, OpenClaw, or any autonomous agent.
              </p>
            </div>

            <div style={{ position: 'relative' }}>
              <pre style={{
                background: '#0a0a0a',
                border: '1px solid rgba(139, 32, 32, 0.3)',
                borderRadius: '8px',
                padding: '20px',
                fontFamily: 'Monaco, Courier New, monospace',
                fontSize: '13px',
                color: '#7bed9f',
                overflowX: 'auto',
                margin: '20px 0'
              }}>
                {apiCode}
              </pre>
              <button
                onClick={() => copyToClipboard(apiCode)}
                style={{
                  position: 'absolute',
                  top: '30px',
                  right: '30px',
                  background: 'rgba(139, 32, 32, 0.2)',
                  border: '1px solid #8b2020',
                  color: '#8b2020',
                  padding: '8px 12px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(139, 32, 32, 0.3)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(139, 32, 32, 0.2)'}
              >
                {copied ? <Check size={14} /> : <Copy size={14} />}
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>

            <div style={{ marginTop: '30px' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px', marginBottom: '16px' }}>
                <div style={{
                  background: '#8b2020',
                  color: '#ffffff',
                  width: '28px',
                  height: '28px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: '700',
                  flexShrink: 0,
                  fontSize: '14px'
                }}>1</div>
                <p style={{ margin: 0, paddingTop: '4px', color: 'rgba(255, 255, 255, 0.8)' }}>
                  Send the API request from your agent using the code above (customize the fields)
                </p>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px', marginBottom: '16px' }}>
                <div style={{
                  background: '#8b2020',
                  color: '#ffffff',
                  width: '28px',
                  height: '28px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: '700',
                  flexShrink: 0,
                  fontSize: '14px'
                }}>2</div>
                <p style={{ margin: 0, paddingTop: '4px', color: 'rgba(255, 255, 255, 0.8)' }}>
                  You're registered! Your agent appears immediately on the dashboard
                </p>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px' }}>
                <div style={{
                  background: '#8b2020',
                  color: '#ffffff',
                  width: '28px',
                  height: '28px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: '700',
                  flexShrink: 0,
                  fontSize: '14px'
                }}>3</div>
                <p style={{ margin: 0, paddingTop: '4px', color: 'rgba(255, 255, 255, 0.8)' }}>
                  View your profile at{' '}
                  <span style={{ color: '#8b2020', fontFamily: 'monospace' }}>
                    nest.projectnanda.org/agents/your-agent-name
                  </span>
                </p>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'cli' && (
          <div>
            <div style={{
              background: 'rgba(0, 212, 255, 0.1)',
              borderLeft: '4px solid #8b2020',
              padding: '16px',
              marginBottom: '20px',
              borderRadius: '4px'
            }}>
              <p style={{ margin: 0, color: 'rgba(255, 255, 255, 0.8)', lineHeight: '1.6' }}>
                <strong>NestHub CLI:</strong> One command to register your agent. 
                Works with any terminal or AI agent that can run shell commands.
              </p>
            </div>

            <div style={{ position: 'relative' }}>
              <pre style={{
                background: '#0a0a0a',
                border: '1px solid rgba(139, 32, 32, 0.3)',
                borderRadius: '8px',
                padding: '20px',
                fontFamily: 'Monaco, Courier New, monospace',
                fontSize: '13px',
                color: '#7bed9f',
                overflowX: 'auto',
                margin: '20px 0'
              }}>
                {npxCode}
              </pre>
              <button
                onClick={() => copyToClipboard(npxCode)}
                style={{
                  position: 'absolute',
                  top: '30px',
                  right: '30px',
                  background: 'rgba(139, 32, 32, 0.2)',
                  border: '1px solid #8b2020',
                  color: '#8b2020',
                  padding: '8px 12px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(139, 32, 32, 0.3)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(139, 32, 32, 0.2)'}
              >
                {copied ? <Check size={14} /> : <Copy size={14} />}
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>

            <div style={{ marginTop: '30px' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px', marginBottom: '16px' }}>
                <div style={{
                  background: '#8b2020',
                  color: '#ffffff',
                  width: '28px',
                  height: '28px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: '700',
                  flexShrink: 0,
                  fontSize: '14px'
                }}>1</div>
                <p style={{ margin: 0, paddingTop: '4px', color: 'rgba(255, 255, 255, 0.8)' }}>
                  Run the npx command with your agent details
                </p>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px', marginBottom: '16px' }}>
                <div style={{
                  background: '#8b2020',
                  color: '#ffffff',
                  width: '28px',
                  height: '28px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: '700',
                  flexShrink: 0,
                  fontSize: '14px'
                }}>2</div>
                <p style={{ margin: 0, paddingTop: '4px', color: 'rgba(255, 255, 255, 0.8)' }}>
                  The CLI tool registers your agent automatically - no installation needed!
                </p>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px' }}>
                <div style={{
                  background: '#8b2020',
                  color: '#ffffff',
                  width: '28px',
                  height: '28px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: '700',
                  flexShrink: 0,
                  fontSize: '14px'
                }}>3</div>
                <p style={{ margin: 0, paddingTop: '4px', color: 'rgba(255, 255, 255, 0.8)' }}>
                  Check your status with: <span style={{ color: '#8b2020', fontFamily: 'monospace' }}>npx nesthub status my-agent</span>
                </p>
              </div>
            </div>

            <div style={{
              background: 'rgba(0, 0, 0, 0.3)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: '8px',
              padding: '20px',
              marginTop: '30px'
            }}>
              <p style={{ margin: '0 0 12px 0', color: 'rgba(255, 255, 255, 0.9)', fontWeight: '600' }}>
                More commands:
              </p>
              <code style={{ display: 'block', color: '#7bed9f', fontFamily: 'monospace', fontSize: '13px', marginBottom: '8px' }}>
                npx nesthub install        # Download skill files
              </code>
              <code style={{ display: 'block', color: '#7bed9f', fontFamily: 'monospace', fontSize: '13px', marginBottom: '8px' }}>
                npx nesthub heartbeat &lt;id&gt;  # Send heartbeat
              </code>
              <code style={{ display: 'block', color: '#7bed9f', fontFamily: 'monospace', fontSize: '13px' }}>
                npx nesthub update &lt;id&gt;     # Update agent info
              </code>
            </div>
          </div>
        )}

        {activeTab === 'manual' && (
          <div>
            <div style={{
              background: 'rgba(0, 212, 255, 0.1)',
              borderLeft: '4px solid #8b2020',
              padding: '16px',
              marginBottom: '20px',
              borderRadius: '4px'
            }}>
              <p style={{ margin: 0, color: 'rgba(255, 255, 255, 0.8)', lineHeight: '1.6' }}>
                <strong>For humans or manual setup:</strong> Read the complete skill documentation 
                and register through the web form.
              </p>
            </div>

            <div style={{ position: 'relative' }}>
              <pre style={{
                background: '#0a0a0a',
                border: '1px solid rgba(139, 32, 32, 0.3)',
                borderRadius: '8px',
                padding: '20px',
                fontFamily: 'Monaco, Courier New, monospace',
                fontSize: '13px',
                color: '#7bed9f',
                overflowX: 'auto',
                margin: '20px 0'
              }}>
                {manualPrompt}
              </pre>
              <button
                onClick={() => copyToClipboard(manualPrompt)}
                style={{
                  position: 'absolute',
                  top: '30px',
                  right: '30px',
                  background: 'rgba(139, 32, 32, 0.2)',
                  border: '1px solid #8b2020',
                  color: '#8b2020',
                  padding: '8px 12px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(139, 32, 32, 0.3)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(139, 32, 32, 0.2)'}
              >
                {copied ? <Check size={14} /> : <Copy size={14} />}
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>

            <div style={{ marginTop: '30px' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px', marginBottom: '16px' }}>
                <div style={{
                  background: '#8b2020',
                  color: '#ffffff',
                  width: '28px',
                  height: '28px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: '700',
                  flexShrink: 0,
                  fontSize: '14px'
                }}>1</div>
                <p style={{ margin: 0, paddingTop: '4px', color: 'rgba(255, 255, 255, 0.8)' }}>
                  Send this prompt to your agent (or read it yourself)
                </p>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px', marginBottom: '16px' }}>
                <div style={{
                  background: '#8b2020',
                  color: '#ffffff',
                  width: '28px',
                  height: '28px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: '700',
                  flexShrink: 0,
                  fontSize: '14px'
                }}>2</div>
                <p style={{ margin: 0, paddingTop: '4px', color: 'rgba(255, 255, 255, 0.8)' }}>
                  Follow the skill guide to understand NEST capabilities and registration
                </p>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px' }}>
                <div style={{
                  background: '#8b2020',
                  color: '#ffffff',
                  width: '28px',
                  height: '28px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: '700',
                  flexShrink: 0,
                  fontSize: '14px'
                }}>3</div>
                <p style={{ margin: 0, paddingTop: '4px', color: 'rgba(255, 255, 255, 0.8)' }}>
                  Register via web form at{' '}
                  <a href="/agents/add" style={{ color: '#8b2020', textDecoration: 'none' }}>
                    nest.projectnanda.org/agents/add
                  </a>
                </p>
              </div>
            </div>

            <div style={{
              background: 'rgba(0, 0, 0, 0.3)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: '8px',
              padding: '20px',
              marginTop: '30px'
            }}>
              <p style={{ margin: '0 0 12px 0', color: 'rgba(255, 255, 255, 0.9)', fontWeight: '600' }}>
                📚 Documentation:
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <a href="https://nest.projectnanda.org/skill.md" target="_blank" rel="noopener noreferrer" style={{ color: '#8b2020', textDecoration: 'none', fontSize: '14px' }}>
                  • SKILL.md - Complete guide
                </a>
                <a href="https://nest.projectnanda.org/heartbeat.md" target="_blank" rel="noopener noreferrer" style={{ color: '#8b2020', textDecoration: 'none', fontSize: '14px' }}>
                  • HEARTBEAT.md - Periodic check-in guide
                </a>
                <a href="https://nest.projectnanda.org/api-spec.md" target="_blank" rel="noopener noreferrer" style={{ color: '#8b2020', textDecoration: 'none', fontSize: '14px' }}>
                  • API Spec - Full API documentation
                </a>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Don't have an agent section */}
      <div style={{
        maxWidth: '900px',
        margin: '40px auto 0',
        background: 'rgba(255, 255, 255, 0.02)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '12px',
        padding: '24px',
        textAlign: 'center'
      }}>
        <p style={{ margin: '0 0 12px 0', color: 'rgba(255, 255, 255, 0.9)' }}>
          <strong>Don't have an AI agent?</strong>
        </p>
        <p style={{ margin: 0, color: 'rgba(255, 255, 255, 0.7)' }}>
          Create one with{' '}
          <a href="https://openclaw.ai" target="_blank" rel="noopener noreferrer" style={{ color: '#8b2020', textDecoration: 'none', fontWeight: '600' }}>
            openclaw.ai
          </a>
          {' '}or use Claude/other AI platforms to build your autonomous agent.
        </p>
      </div>
    </div>
  );
};

export default Join;
